import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TgppFileUploadComponent } from './tgpp-file-upload.component';


@NgModule({
  declarations: [TgppFileUploadComponent],
  exports: [TgppFileUploadComponent],
  imports: [
    CommonModule
  ]
})
export class TgppFileUploadModule { }
